export const setAddressMixin = {
  data() {
    return {
      place: null,
      location: {
        name: null,
        street1: null,
        street2: null,
        street3: null,
        city: null,
        state: null,
        postcode: null,
        country: null,
        coordinates: []
      }
    };
  },
  methods: {
    setAddress(place) {
      if (place && place.geometry) {
        const street_number = place.address_components.filter(function(ac) {
          return ac.types.indexOf("street_number") != -1;
        });
        const street_route = place.address_components.filter(function(ac) {
          return ac.types.indexOf("route") != -1;
        });

        const area = place.address_components.filter(function(ac) {
          return ac.types.indexOf("locality") != -1;
        });

        const townCity = place.address_components.filter(function(ac) {
          return ac.types.indexOf("postal_town") != -1;
        });

        const county = place.address_components.filter(function(ac) {
          return ac.types.indexOf("administrative_area_level_2") != -1;
        });

        const postcode = place.address_components.filter(function(ac) {
          return ac.types.indexOf("postal_code") != -1;
        });

        const country = place.address_components.filter(function(ac) {
          return ac.types.indexOf("country") != -1;
        });

        this.place = place.formatted_address;

        this.location.name = place.formatted_address;

        this.location.street1 =
          (street_number.length ? street_number[0].long_name + " " : "") +
            (street_route.length ? street_route[0].long_name : "") ||
          place.name;

        this.location.street2 = null;

        this.location.street3 = area && area.length ? area[0].long_name : null;

        this.location.city =
          townCity && townCity.length ? townCity[0].long_name : null;

        this.location.state =
          county && county.length ? county[0].long_name : null;

        this.location.postcode =
          postcode && postcode.length ? postcode[0].long_name : null;

        this.location.country =
          country && country.length ? country[0].long_name : null || null;

        if (place.geometry.location) {
          if (typeof this.location.coordinates != Array)
            this.location.coordinates = [];
          this.location.coordinates[0] = place.geometry.location.lng();
          this.location.coordinates[1] = place.geometry.location.lat();
        }
      }
    }
  }
};
